<ng-template #rowButtons>
    <div class="d-flex w-100" style="justify-content: space-between">
        <ng-container
            *ngFor="let button of buttons; trackBy: trackButton; let i = index"
        >
            <ng-container *ngIf="isVisible(button); else emptyButton">
                <button
                    class="btn-action ml-1"
                    [disabled]="isDisabled(button)"
                    [ngClass]="getClass(button)"
                    [ngStyle]="getStyle(button)"
                    (click)="onClick(button)"
                    [matTooltip]="
                        getTooltip(button) | translate : button.tooltipParams
                    "
                    matRipple
                    [attr.data-test]="button.dataTest"
                >
                    <i class="material-icons">{{ button.icon }}</i>
                </button>
            </ng-container>
        </ng-container>
    </div>
</ng-template>

<ng-template #emptyButton> </ng-template>
